export default "__VITE_ASSET__DPkoU0dV__"